module.exports = __webpack_public_path__ + "fonts/Waldorf-Pro-Regular.c7a203b.otf";